import { createContext } from "react";

const medContext=createContext();

export default medContext;